import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { MovingHead, TrussBar } from "./StageDecor";
import MagneticButton from "../ui/MagneticButton";

export default function CTASection() {
    return (
        <section
            className="relative py-24 sm:py-32 px-6 sm:px-12 overflow-hidden"
            data-testid="cta-section"
        >
            <div className="absolute inset-0 bg-nova-black" />
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,153,255,0.12),transparent_60%)]" />
            <div className="absolute inset-0 grid-bg opacity-40" />

            {/* Truss with moving heads aiming at the CTA */}
            <div className="absolute top-0 left-0 right-0 z-[2] pointer-events-none select-none hidden md:block">
                <TrussBar width={1600} className="opacity-50" />
                <div className="absolute top-8 left-0 right-0 flex justify-center gap-[12%] px-[10%]">
                    {[
                        { c: "#0099FF", tiltAngle: 12,  tiltRange: 10, dur: 7  },
                        { c: "#0055CC", tiltAngle: -6,  tiltRange: 8,  dur: 9  },
                        { c: "#5ABAFF", tiltAngle: 4,   tiltRange: 12, dur: 8  },
                        { c: "#0055CC", tiltAngle: -14, tiltRange: 9,  dur: 11 },
                    ].map((m, i) => (
                        <MovingHead
                            key={i}
                            color={m.c}
                            tiltAngle={m.tiltAngle}
                            tiltRange={m.tiltRange}
                            animDuration={m.dur}
                            autoTilt={true}
                            beamOpacity={0.3}
                            size={80}
                        />
                    ))}
                </div>
            </div>

            <div className="relative max-w-5xl mx-auto text-center">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                >
                    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-sm border border-nova-purple/25 bg-nova-purple/5 mb-8">
                        <span className="w-2 h-2 rounded-full bg-nova-purple animate-pulse" />
                        <span className="font-mono text-xs uppercase tracking-[0.2em] text-nova-purple">
                            Voľné termíny na sezónu
                        </span>
                    </div>

                    <h2 className="font-heading text-4xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[1.02]">
                        Plánujete event?
                    </h2>
                    <h3 className="mt-4 font-heading text-3xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[1.05]">
                        <span className="text-gradient">
                            Postaráme sa o jeho technickú stránku.
                        </span>
                    </h3>

                    <p className="mt-8 text-lg text-zinc-400 max-w-2xl mx-auto">
                        Napíšte nám a do 24 hodín vám pošleme nezáväzné
                        technické riešenie aj s cenovou kalkuláciou.
                    </p>

                    <div className="mt-12 flex flex-wrap justify-center gap-4">
                        <MagneticButton>
                            <Link
                                to="/kontakt"
                                className="group inline-flex items-center h-13 px-10 rounded-md bg-nova-cyan text-black hover:bg-nova-cyan hover:saturate-125 font-semibold text-base transition-all hover:shadow-[0_0_30px_rgba(0,153,255,0.4)]"
                                data-testid="cta-request-quote"
                            >
                                Požiadať o cenovú ponuku
                                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                            </Link>
                        </MagneticButton>
                    </div>

                    <div className="mt-16 flex flex-wrap justify-center items-center gap-8 text-sm text-zinc-500">
                        <div className="flex items-center gap-2">
                            <span className="w-1.5 h-1.5 rounded-full bg-nova-cyan" />
                            Odpoveď do 24h
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="w-1.5 h-1.5 rounded-full bg-nova-purple" />
                            Nezáväzná konzultácia
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="w-1.5 h-1.5 rounded-full bg-nova-cyan" />
                            Riešenia na mieru
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
